import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ServicePageContent from '../Components/Services/ServicePageContent'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function ServiceDetails() {
    const { id } = useParams();
    const { t } = useTranslation();

    const serviceTypeMap = {
        'single-room': 'singleRoom',
        'double-room': 'doubleRoom',
        'triple-room': 'tripleRoom',
        'quad-room': 'quadRoom',
        'six-room': 'sixRoom',
        'social-areas': 'socialAreas',
        'transportation': 'transportation',
        'nearby-places': 'nearbyPlaces',
        'nearby-universities': 'nearbyUniversities',
    };

    const serviceKey = serviceTypeMap[id] || 'singleRoom';
    const pageTitle = t(`service.${serviceKey}.title`);
    const pageDescription = t(`service.${serviceKey}.description`);

    return (
        <>
            <SEO 
                title={`${pageTitle} - Haseki Sultan Kız Öğrenci Yurdu`}
                description={pageDescription}
                url={`/service/${id}`}
            />
            <HeaderOne />
            <Breadcrumb
                title={pageTitle}
            />
            <ServicePageContent serviceType={id} />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ServiceDetails
